import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseButton = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			fill: "#6E99F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.53764 6C9.00466 6 8.57141 6.45529 8.57141 7.01647V16.9835C8.57141 17.5447 9.00466 18 9.53764 18C10.0706 18 10.5039 17.5447 10.5039 16.9835V7.01647C10.5039 6.45529 10.0706 6 9.53764 6Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4623 6C13.9293 6 13.4961 6.45529 13.4961 7.01647V16.9835C13.4961 17.5447 13.9293 18 14.4623 18C14.9953 18 15.4286 17.5447 15.4286 16.9835V7.01647C15.4286 6.45529 14.9953 6 14.4623 6Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgPauseButton);
export default ForwardRef;
